import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import downloadTemplate from "../../../utilities/downloadCsv";
import {
  Card,
  Row,
  Col,
  Table,
  Button,
  Form,
  Badge,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FiEdit,
  FiTrash2,
  FiArrowLeft,
  FiPhone,
  FiMoreVertical,
} from "react-icons/fi";
import { FiInfo } from "react-icons/fi";
import { useAuth, errorCheck } from "../auth/auth-utils";
import { postApiMediaCall } from "../../../service/postApiCall";
import { toast } from 'react-toastify';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  API_CONTACT_GROUP_MEMBERS_UPDATE,
  API_CONTACT_GROUP_MEMBERS_DELETE,
  API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP,
  API_CONTACT_GROUP_MEMBERS_UPLOAD,
} from "../../../service/url";
import exportData from "../../../utilities/export";

import { UPLOAD_CONTACT_GROUP_MEMBERS, UPLOAD_CONTACT_GROUP_MEMBERS_DATA } from "../../../utilities/constant";

const GroupDetail = () => {
  const { checkAuth } = useAuth();
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [currentContact, setCurrentContact] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [isFileUpload, setIsFileUpload] = useState(false);
  const textRegex = /^[a-zA-Z0-9 ]*$/;

  function changeUploadFile(e) {
    const file = e.target.files[0];
    if (file && file.type === "text/csv") {
      setUploadFile(file);
      setIsFileUpload(true);
    } else {
      // setToastProps({
      //   message: "Please upload a CSV file.",
      //   type: "danger",
      // });
          toast.error("Please upload a CSV file.");
      setUploadFile(null);
      setIsFileUpload(false);
    }
  }

  const group = state?.group || {
    id: 1,
    name: "Sample Group",
    members: 2,
    createdBy: "admin",
    createdOn: "10 Jul 2025, 10:00:00 AM",
    description: "This is a sample contact group",
  };

  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const url = API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP.replace(":id", id);
    getApiCall(url, {}).then(onListSuccess).catch(onError);
  }, []);

  function onListSuccess(resp) {
    setContacts(resp);
  }

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const handleEditClick = (contact) => {
    setCurrentContact(contact);
    setShowEditModal(true);
  };

  const handleModalClose = () => {
    setShowEditModal(false);
    setCurrentContact(null);
  };

  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("Contact_Group_Members", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  const [buttonDisable, setButtonDisable] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleCloseUploadModal = () => setShowUploadModal(false);
  const handleShowUploadModal = () => setShowUploadModal(true);

  const getColumnsAndFilename = () => {
    const columns = UPLOAD_CONTACT_GROUP_MEMBERS;
    const filename = "Contact_Group_Members-Upload.csv";
    const sample_data = UPLOAD_CONTACT_GROUP_MEMBERS_DATA;

    return { columns, filename, sample_data };
  };
  const numberRegex = /^\d{10}$/; 
  const handleSaveUpload = () => {
    const formData = new FormData();
    formData.append("contact_group_id", id);
    formData.append("members_data", uploadFile);

    postApiMediaCall(API_CONTACT_GROUP_MEMBERS_UPLOAD, formData)
      .then((resp) => {
        onUploadSuccess(resp);
      })
      .catch((err) => {
        onUploadError(err);
      });
  };

  function onUploadSuccess(resp) {
    // setToastProps({
    //   message: "Members Data uploaded successfully",
    //   type: "success",
    // });
        toast.success("Members Data uploaded successfully");
    handleCloseUploadModal();
    const url = API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP.replace(":id", id);
    getApiCall(url, {}).then(onListSuccess).catch(onError);
  }

  function onUploadError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.error("Data creation error:", err);
      setButtonDisable(false);
      toast.error(JSON.stringify(err));
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Fields that must allow only numbers
    const numberFields = ["primary_number", "alt1_number", "alt2_number"];

    if (numberFields.includes(name)) {
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);
      setCurrentContact((prev) => ({
        ...prev,
        [name]: cleanedValue,
      }));
      return;
    }

    // 🚫 Block special characters for text fields
    if (!textRegex.test(value)) {
      return; // stop updating state (prevents typing special chars)
    }

    setCurrentContact((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveChanges = (e) => {
    e.preventDefault();

    // Create a trimmed copy of the current contact for validation
    const trimmedContact = {
      ...currentContact,
      first_name: currentContact.first_name?.trim(),
      last_name: currentContact.last_name?.trim(),
      street: currentContact.street?.trim(),
      city: currentContact.city?.trim(),
      state: currentContact.state?.trim(),
      country: currentContact.country?.trim(),
      company: currentContact.company?.trim(),
      primary_number: currentContact.primary_number?.trim(),
      alt1_number: currentContact.alt1_number?.trim(),
      alt2_number: currentContact.alt2_number?.trim(),
    };

    // Validation: Check required fields are not empty or whitespace
    if (
      !trimmedContact.first_name ||
      !trimmedContact.last_name ||
      !trimmedContact.primary_number ||
      !trimmedContact.street ||
      !trimmedContact.city ||
      !trimmedContact.state ||
      !trimmedContact.country ||
      !trimmedContact.company
    ) {
      // setToastProps({
      //   message: "Please fill in all required fields with valid values",
      //   type: "danger",
      // });
          toast.error("Please fill in all required fields with valid values");
      setShowToast(true);
      return;
    }

    // Validate primary number is exactly 10 digits (numbers only)
    if (!/^\d{10}$/.test(trimmedContact.primary_number)) {
      // setToastProps({
      //   message: "Primary number must be exactly 10 digits",
      //   type: "danger",
      // });
          toast.error("Primary number must be exactly 10 digits");
      setShowToast(true);
      return;
    }

    // Validate alternate numbers if they exist (must be exactly 10 digits or empty/null)
    if (
      trimmedContact.alt1_number &&
      !/^\d{10}$/.test(trimmedContact.alt1_number)
    ) {
      // setToastProps({
      //   message: "Alternate number 1 must be exactly 10 digits or empty",
      //   type: "danger",
      // });
          toast.error("Alternate number 1 must be exactly 10 digits or empty");
      setShowToast(true);
      return;
    }

    if (
      trimmedContact.alt2_number &&
      !/^\d{10}$/.test(trimmedContact.alt2_number)
    ) {
      // setToastProps({
      //   message: "Alternate number 2 must be exactly 10 digits or empty",
      //   type: "danger",
      // });
          toast.error("Alternate number 2 must be exactly 10 digits or empty");
      setShowToast(true);
      return;
    }

    // Required validation
    if (
      !trimmedContact.first_name ||
      !trimmedContact.last_name ||
      !trimmedContact.primary_number ||
      !trimmedContact.street ||
      !trimmedContact.city ||
      !trimmedContact.state ||
      !trimmedContact.country ||
      !trimmedContact.company
    ) {
      toast.error("Please fill in all required fields with valid values");
      return;
    }

    // 🚫 Special character validation
    const textFields = [
      { key: "First Name", value: trimmedContact.first_name },
      { key: "Last Name", value: trimmedContact.last_name },
      { key: "Street", value: trimmedContact.street },
      { key: "City", value: trimmedContact.city },
      { key: "State", value: trimmedContact.state },
      { key: "Country", value: trimmedContact.country },
      { key: "Company", value: trimmedContact.company },
    ];

    for (let field of textFields) {
      if (!textRegex.test(field.value)) {
        toast.error(`${field.key} must not contain special characters`);
        return;
      }
    }

    // Phone validation
    if (!numberRegex.test(trimmedContact.primary_number)) {
      toast.error("Primary number must be exactly 10 digits");
      return;
    }

    if (
      trimmedContact.alt1_number &&
      !numberRegex.test(trimmedContact.alt1_number)
    ) {
      toast.error("Alternate number 1 must be exactly 10 digits");
      return;
    }

if (
  trimmedContact.alt2_number &&
  !numberRegex.test(trimmedContact.alt2_number)
) {
  toast.error("Alternate number 2 must be exactly 10 digits");
  return;
}

// Prevent duplicate numbers
const numbers = [
  trimmedContact.primary_number,
  trimmedContact.alt1_number,
  trimmedContact.alt2_number,
].filter(Boolean);

if (new Set(numbers).size !== numbers.length) {
  toast.error("Phone numbers must not be duplicated");
  return;
}

    const payload = {
      first_name: trimmedContact.first_name,
      last_name: trimmedContact.last_name,
      street: trimmedContact.street,
      city: trimmedContact.city,
      state: trimmedContact.state,
      country: trimmedContact.country,
      company: trimmedContact.company,
      contact_group_id: id,
      primary_number: trimmedContact.primary_number,
      alt1_number: trimmedContact.alt1_number || null, // Convert empty string to null
      alt2_number: trimmedContact.alt2_number || null, // Convert empty string to null
    };

    const url = API_CONTACT_GROUP_MEMBERS_UPDATE.replace(
      ":id",
      currentContact.id
    );
    postApiCall(url, payload).then(onUpdateSuccess).catch(onUpdateError);
  };

  useEffect(() => {
    if (toastProps) {
      setShowToast(true);
    }
  }, [toastProps]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast);
  }, []);

  function onUpdateError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: "danger" });
          toast.error(JSON.stringify(err));
    }
  }

  function onUpdateSuccess(resp) {
    // setToastProps({
    //   message: "Contact Member updated successfully",
    //   type: "success",
    // });
        toast.success("Contact Member updated successfully");
    handleModalClose();
    const url = API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP.replace(":id", id);
    getApiCall(url, {}).then(onListSuccess).catch(onError);
  }

  const filteredContacts = contacts.filter(
    (contact) =>
      `${contact.first_name} ${contact.last_name}`
        .toLowerCase()
        .includes(searchValue.toLowerCase()) ||
      contact?.primary_number?.includes(searchValue) ||
      contact?.company?.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleDeleteClick = (contactId) => {
    setContactToDelete(contactId);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    const url = API_CONTACT_GROUP_MEMBERS_DELETE.replace(
      ":id",
      contactToDelete
    );
    postApiCall(url, { id: contactToDelete })
      .then(onDeleteSuccess)
      .catch(onDeleteError);
    setShowDeleteModal(false);
    setContactToDelete(null);
  };

  function onDeleteSuccess(resp) {
    // setToastProps({
    //   message: "Contact deleted successfully",
    //   type: "success",
    // });
        toast.success("Contact deleted successfully");
    setShowToast(true);
    const url = API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP.replace(":id", id);
    getApiCall(url, {}).then(onListSuccess).catch(onError);
  }

  function onDeleteError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      setButtonDisable(false);
      toast.error(JSON.stringify(err));
      setShowToast(true);
    }
  }

  return (
    <div className="group-detail-container">
      <Row>
        <Col sm="12">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-0">
              <div className="header-title px-4 py-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <Button
                    variant="link"
                    className="p-0 me-3"
                    onClick={() => navigate(-1)}
                  >
                    <FiArrowLeft size={20} />
                  </Button>
                  <div>
                    <h4 className="card-title m-0">
                      Contact Group Member Details
                    </h4>
                  </div>
                </div>
              </div>

              <div className="px-4 py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Search contacts..."
                    style={{ width: "300px" }}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                  <div className="d-flex" style={{ gap: "8px" }}>
                    {contacts.length > 0 && (
                      <Button
                        label="Export Data"
                        onClick={handleExport}
                        className="p-button-active"
                        disabled={buttonDisable}
                      >
                        &nbsp;
                        {buttonDisable && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                        Export
                      </Button>
                    )}
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="primary"
                        id="dropdown-add-contact"
                      >
                        Add Contact
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() =>
                            navigate(
                              `/contact-group/${group.id}/create-contact`
                            )
                          }
                        >
                          Create Contact
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleShowUploadModal}>
                          Upload Contact
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            navigate(
                              `/contact-group/${group.id}/import-members`
                            )
                          }
                        >
                          Import Contact Members
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Upload Contact Modal */}
                    <Modal
                      show={showUploadModal}
                      onHide={handleCloseUploadModal}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Upload Contacts</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p>
                          Download the sample template and upload in same way.
                        </p>
                        <Button
                          variant="btn btn-primary btn-sm mb-4"
                          onClick={(event) => {
                            const { columns, filename, sample_data } =
                              getColumnsAndFilename();
                            downloadTemplate(event, columns, filename, null, sample_data);
                          }}
                        >
                          Download Template
                        </Button>

                        <Form.Control
                          type="file"
                          className="form-control"
                          onChange={(e) => changeUploadFile(e)}
                          accept=".csv"
                          required
                        />
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={handleCloseUploadModal}
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSaveUpload}>
                          Save
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>

                <DataTable
                  value={filteredContacts}
                  dataKey="id"
                  responsive
                  className="p-datatable-bordered p-datatable-hover"
                  emptyMessage={
                    <div className="text-center py-4">
                      {searchValue
                        ? "No contacts match your search"
                        : "No contacts in this group yet"}
                    </div>
                  }
                >
                  <Column
                    header="Name"
                    sortable
                    sortField="first_name"
                    body={(rowData) =>
                      `${rowData.first_name} ${rowData.last_name}`
                    }
                  />
                  <Column field="primary_number" header="Number" sortable />
                  <Column
                    header="Address"
                    body={(rowData) => {
                      const { street, city, state, country, id } = rowData;
                      const fullAddress = [street, city, state, country]
                        .filter(Boolean)
                        .join(", ");

                      return (
                        <div className="d-flex align-items-center gap-1">
                          <span>{street || "-"}</span>

                          {fullAddress && (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-${id}`}>
                                  {fullAddress}
                                </Tooltip>
                              }
                            >
                              <span
                                style={{ cursor: "pointer", color: "#007bff" }}
                              >
                                <FiInfo size={14} />
                              </span>
                            </OverlayTrigger>
                          )}
                        </div>
                      );
                    }}
                  />

                  <Column
                    field="company"
                    header="Company"
                    sortable
                    body={(rowData) => rowData.company || "-"}
                  />
                  <Column
                    header="Actions"
                    body={(rowData) => (
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="text-primary p-0 me-2"
                        >
                          <FiPhone size={18} />
                        </Button>

                        <Dropdown>
                          <Dropdown.Toggle
                            variant="link"
                            className="p-0 text-dark"
                          >
                            <FiMoreVertical size={18} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => handleEditClick(rowData)}
                            >
                              <FiEdit className="me-2" /> Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleDeleteClick(rowData.id)}
                              className="text-danger"
                            >
                              <FiTrash2 className="me-2" /> Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                  />
                </DataTable>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showEditModal} onHide={handleModalClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentContact && (
            <Form
              style={{
                maxHeight: "calc(100vh - 250px)",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={currentContact.first_name}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value.trim(),
                          },
                        });
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Last Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={currentContact.last_name}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value.trim(),
                          },
                        });
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>
                  Primary Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="tel"
                  name="primary_number"
                  value={currentContact.primary_number}
                  onChange={(e) => {
                    const cleanedValue = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    handleInputChange({
                      target: {
                        name: "primary_number",
                        value: cleanedValue,
                      },
                    });
                  }}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
                <Form.Text className="text-muted">
                  {currentContact.primary_number.length === 10
                    ? "✓ Valid 10-digit number"
                    : "Enter 10 digits (numbers only)"}
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Alternate Number 1 (Optional)</Form.Label>
                <Form.Control
                  type="tel"
                  name="alt1_number"
                  value={currentContact.alt1_number}
                  onChange={(e) => {
                    const cleanedValue = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    handleInputChange({
                      target: {
                        name: "alt1_number",
                        value: cleanedValue,
                      },
                    });
                  }}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
                <Form.Text className="text-muted">
                  {currentContact?.alt1_number?.length === 10
                    ? "✓ Valid 10-digit number"
                    : "Enter 10 digits (numbers only)"}
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Alternate Number 2 (Optional)</Form.Label>
                <Form.Control
                  type="tel"
                  name="alt2_number"
                  value={currentContact.alt2_number}
                  onChange={(e) => {
                    const cleanedValue = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    handleInputChange({
                      target: {
                        name: "alt2_number",
                        value: cleanedValue,
                      },
                    });
                  }}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
                <Form.Text className="text-muted">
                  {currentContact?.alt2_number?.length === 10
                    ? "✓ Valid 10-digit number"
                    : "Enter 10 digits (numbers only)"}
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Street Address <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="street"
                  value={currentContact.street}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      City <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={currentContact.city}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value.trim(),
                          },
                        });
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      State/Province <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="state"
                      value={currentContact.state}
                      onChange={handleInputChange}
                      onBlur={(e) => {
                        handleInputChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value.trim(),
                          },
                        });
                      }}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>
                  Country <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  value={currentContact.country}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  Company <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="company"
                  value={currentContact.company}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.value.trim(),
                      },
                    });
                  }}
                  required
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this contact? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
  );
};

export default GroupDetail;
